<template>
  <v-app class="helmi-app">
    <v-navigation-drawer
      v-if="showMenu"
      v-model="drawer"
      app
      clipped
      width="300"
    >
      <v-sheet
        v-if="currentProperty && currentProperty.kohdenimi"
        class="pb-1 mb-4"
      >
        <v-list-item
          class="pt-4"
        >
          <v-list-item-avatar
            v-if="currentProperty.kuva.endsWith('/')"
            class="mr-3"
            color="secondary white--text"
            v-text="propertyInitials"
          />
          <v-list-item-avatar
            v-else
            class="mr-3"
          >
            <v-img :src="currentProperty.kuva"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ currentProperty.kohdenimi }} {{ currentProperty.huoneistonro }}
            </v-list-item-title>
            <p class="grey--text text--darken-1 body-2">
              {{ currentProperty.postinumero }} {{ currentProperty.kaupunki }}
            </p>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="currentProperty && currentProperty.propertypath"
          link
          class="mb-1"
          :href="currentProperty.propertypath"
        >
          <v-list-item-icon>
            <v-icon>keyboard_arrow_left</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Takaisin toimeksiantoon</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider/>
      </v-sheet>
      <v-list shaped>
        <v-list-item
          v-for="item of menu"
          :key="item.title"
          :href="item.href || null"
          class="active"
          color="primary"
          :to="!!item.to ? { name: item.to, params: {
            companyId: item.companyId || $route.params.companyId,
          }} : null"
          @click="item.method ? item.method() : null"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-if="userDetails.belongsToGroup && $route.name !== 'fileSignList'">
          <v-divider class="my-4"/>
          <v-list-group
            :value="true"
            prepend-icon="account_tree"
          >
            <template v-slot:activator>
              <v-list-item-title>Konserninäkymä</v-list-item-title>
            </template>

            <v-list-item
              v-for="item of groupMenu"
              :key="item.title"
              class="active"
              color="primary"
              :to="{ name: item.to, params: {
                companyId: item.companyId || $route.params.companyId,
              }}"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
      <template v-if="userDetails" v-slot:append>
        <v-divider class="mb-2"/>
        <v-list-item>
          <v-list-item-icon class="mr-3 mt-4 ml-1">
            <v-icon>person</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ userDetails.nimi }}</v-list-item-title>
            <v-list-item-subtitle>{{ userDetails.asema }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-row class="mt-0 mb-3" justify="center">
          <v-btn
            rounded
            color="black"
            text
            small
            @click="logout()"
          >
            Kirjaudu ulos
          </v-btn>
        </v-row>
      </template>
    </v-navigation-drawer>
    <v-app-bar
      v-if="isAuthorized === true && dashboard"
      app
      clipped-left
      clipped-right
      height="56"
      class="white custom-elevation"
    >
      <v-app-bar-nav-icon
        v-if="showMenu && $vuetify.breakpoint.mdAndDown"
        :class="$vuetify.breakpoint.smAndDown ? 'mr-2' : 'mr-5'"
        class="ml-1"
        @click.stop="drawer = !drawer"
      />
      <v-col>
        <v-row
          class="clickable nowrap"
          align="center"
          @click="goHome()"
        >
          <helmi-icon :size="30"/>
          <p class="helmi-navigation__title pl-2 mb-0">
            HELMI
          </p>
        </v-row>
      </v-col>
      <v-spacer/>
      <p v-if="$vuetify.breakpoint.smAndUp" class="company-name mb-0">
        {{ userDetails.yritysnimi }}
      </p>
    </v-app-bar>
    <v-main class="grey lighten-4">
      <v-slide-y-reverse-transition mode="out-in">
        <router-view/>
      </v-slide-y-reverse-transition>
    </v-main>
    <v-overlay
      :value="globalLoader"
      color="white"
      opacity="0.9"
    >
      <v-card-text style="width:400px;text-align:center">
        <h2 class="primary--text">
          {{ customTitle ? customTitle : 'Käsitellään...' }}
        </h2>
        <p class="grey--text text--darken-1 caption">
          Odota hetki
        </p>
        <v-progress-linear
          class="my-4"
          color="primary"
          height="4"
          buffer-value="0"
          stream
          indeterminate
        />
      </v-card-text>
    </v-overlay>
  </v-app>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { apiGet } from './api';

export default {
  name: 'App',
  components: {
    HelmiIcon: () => import('@/components/Icon.vue'),
  },
  data: () => ({
    drawer: false,
    item: 0,
    customTitle: null,
    globalLoader: false,
  }),
  computed: {
    ...mapGetters({
      companyName: 'companyName',
      isAuthorized: 'isAuthorized',
      userDetails: 'userDetails',
    }),
    ...mapState({
      currentProperty: state => state.currentProperty,
      agent: state => state.agent,
      dashboard: state => state.dashboard,
    }),
    isNotEdge() {
      // Internet Explorer 6-11
      const isIE = /* @cc_on!@ */false || !!document.documentMode;

      // Edge 20+
      const isEdge = !isIE && !!window.StyleMedia;

      if (isIE) return false;
      if (isEdge) return false;
      return true;
    },

    menu() {
      if (['profile', 'searchWatch', 'buyorderlist', 'buyorder', 'offer', 'newOffer', 'taxtransfer', 'groupDashboard', 'groupProperties'].includes(this.$route.name) && this.agent) {
        return [
          {
            title: 'Toimeksiantolistaus',
            icon: 'home_work',
            href: `${this.userDetails.rootpath}/hallinta.php`,
          },
          {
            title: 'Ostotoimeksiannot',
            icon: 'ballot',
            to: 'buyorderlist',
          },
          {
            title: 'Hakuvahdit',
            icon: 'search',
            to: 'searchWatch',
            companyId: this.userDetails?.companyId,
          },
          {
            title: 'Ilmoitukset',
            href: `${this.userDetails.rootpath}/hallinta.php?sivu=ilmoitukset`,
            icon: 'campaign',
          },
          {
            title: 'Omat työkalut',
            href: `${this.userDetails.rootpath}/hallinta.php?sivu=omat`,
            icon: 'speed',
          },
          {
            title: 'Asiakasrekisteri',
            href: `${this.userDetails.rootpath}/hallinta.php?sivu=asiakasrekisteri`,
            icon: 'supervisor_account',
          },
          {
            title: 'Raportit',
            href: `${this.userDetails.rootpath}/hallinta.php?sivu=raportit`,
            icon: 'bar_chart',
          },
          {
            title: 'Oma profiili',
            to: 'profile',
            icon: 'person',
          },
          ...(+(this.userDetails?.paakayttaja || 0) === 1 ? [{
            title: 'Asetukset',
            href: `${this.userDetails.rootpath}/hallinta.php?sivu=asetukset`,
            icon: 'settings',
          }] : []),
          // ...(this.userDetails?.group ? [{
          //   title: 'Konserninäkymä',
          //   to: 'groupDashboard',
          //   icon: 'line_axis',
          // }] : []),
        ];
      }

      return [];
    },

    groupMenu() {
      return [
        ...(this.userDetails?.group ? [{
          title: 'Vuosittainen tuotto',
          to: 'groupDashboard',
          icon: 'line_axis',
        }] : []),
        {
          title: 'Kaikki kohteet',
          to: 'groupProperties',
          icon: 'home_work',
        },
      ];
    },
    propertyInitials() {
      if (!this.currentProperty) return '';

      return this.currentProperty.kohdenimi
        .split(' ')
        .slice(0, 2)
        .map(p => p.slice(0, 1))
        .join('')
        .toUpperCase();
    },

    showMenu() {
      if (this.agent && this.dashboard) return true;
      return false;
    },
  },
  created() {
    this.drawer = this.$vuetify.breakpoint.lgAndUp;
    this.$bus.$on('SHOW_GLOBAL_LOADER', (title) => {
      this.customTitle = title;
      this.globalLoader = true;
    });
    this.$bus.$on('HIDE_GLOBAL_LOADER', () => {
      this.customTitle = null;
      this.globalLoader = false;
    });
  },
  methods: {
    ...mapActions({
      setAuthorization: 'setAuthorization',
      setAgent: 'setAgent',
    }),
    goHome() {
      if (this.agent) {
        window.location = `${this.userDetails.rootpath}/hallinta.php`;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goToSearchWatch() {
      const params = { companyId: this.userDetails?.companyId };
      this.$router.push({ name: 'searchWatch', params });
    },
    closeOnMobile() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false;
      }
    },
    async logout() {
      const path = `${this.userDetails.rootpath}/hallinta.php`;
      await apiGet('authorization/logout');
      this.setAuthorization(false);
      this.setAgent(false);
      window.location = path;
    },
  },
};
</script>

<style lang="scss">
.helmi-app {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .v-card__title,
  .v-toolbar__title,
  // .v-list-item__title,
  .v-subheader,
  .v-btn,
  .v-tab,
  .text-h1,
  .text-h2,
  .text-h3,
  .text-h4,
  .text-h5,
  .text-h6,
  .text-subtitle-1,
  .text-subtitle-2,
  .dosis,
  .v-expansion-panel-header strong {
    font-family: 'Roboto', sans-serif !important;
  }

  .v-expansion-panel-header strong {
    font-size: 1.125rem;
    letter-spacing: 0.75px;
  }

  .v-btn.v-btn--rounded {
    font-family: "Roboto", sans-serif !important;
  }

  .v-btn:not(.v-btn--rounded) {
    font-weight: 500;
    font-size: 1rem;
    text-transform: none;
  }

  .v-tab {
    // font-size: 1rem;
    text-transform: none;
    letter-spacing: 0;
  }

  .v-subheader {
    font-size: 1rem;
  }

  .p-relative {
    position: relative;
  }

  .roboto {
    font-family: Roboto, 'sans-serif' !important;
  }

  .text-color {
    color: rgba(0, 0, 0, 0.54);
  }

  .title-color {
    color: rgba(0, 0, 0, 0.87);
  }
}

.helmi-navigation__title {
  font-family: 'Exo 2', sans-serfif;
  font-weight: 600;
  font-size: 20px;
  margin-left: 2px;
  line-height: 20px;
  align-self: center;
  color: #000;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: 0 3px 10px -2px rgb(85 85 85 / 8%),
      0 2px 20px 0 rgb(85 85 85 / 6%),
      0 1px 30px 0 rgb(85 85 85 / 3%);
}

.helmi-card-title {
  font-family: Quicksand,sans-serif !important;
  font-size: 18px;
  font-weight: 700;
  padding-bottom: 8px;
  color: rgba(0, 0, 0, 0.87) !important;
}

.font-quicksand, .font-quicksand .v-btn__content {
  font-family: Quicksand,sans-serif !important;
}

p.company-name {
  font-family: Quicksand,sans-serif !important;
  font-size: 14px;
  font-weight: 700;
}

.helmi-card-subtitle {
  font-family: Quicksand, sans-serif !important;
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.80) !important;
}

.custom-elevation {
  box-shadow: 0 2px 30px -1px rgb(85 85 85 / 8%),
  0 4px 30px 0 rgb(85 85 85 / 6%),
  0 1px 30px 0 rgb(85 85 85 / 3%) !important;
}

.nowrap {
  flex-wrap: nowrap;
}

.clickable > * {
  cursor: pointer;
}

.container {
  padding: 24px 24px;
}

.v-sheet.v-card.helmi-card {
  border-radius: 8px;
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);
  outline: 1px solid rgb(234, 235, 235);
  outline-offset: -1px;
  border-radius: 8px;
}

.v-main__wrap {
  background-image: linear-gradient(
    45deg,
    #d0d2d2 0% 10%,
    #d5d7d7 10% 20%,
    #dbdcdc 20% 30%,
    #e0e1e1 30% 40%,
    #e5e6e6 40% 50%,
    #eaebeb 50% 60%,
    #eff0f0 60% 70%,
    #f5f5f5 70% 80%,
    #fafafa 80% 90%,
    #fff 90% 100%
  );
  background-attachment: fixed;
}
</style>
